// @flow
import {
  MAIN_DEAL_TYPES_ID,
  PROPERTY_TYPES_GROUPED_BY_DEAL_TYPES,
} from '../../common/constants/homes';

export function notOnlyExistMainDealType(dealTypes: Array<Number>): boolean {
  return dealTypes.some((dealType: Number) => MAIN_DEAL_TYPES_ID.indexOf(dealType) === -1);
}

export function isMainDealType(dealType: Number) {
  return !notOnlyExistMainDealType([dealType]);
}

export function getPropertyTypesByDealTypeId(dealType: Number): Array<Object> {
  if (!PROPERTY_TYPES_GROUPED_BY_DEAL_TYPES[dealType]) {
    return [];
  }

  return PROPERTY_TYPES_GROUPED_BY_DEAL_TYPES[dealType];
}

export function pickPropertyTypes(
  propertyTypes: Array<Object>,
  dealTypePropertiesToPick: Array<Number>
): Array<Object> {
  return propertyTypes.reduce((acc: Array<Object>, current): Array<Object> => {
    if (dealTypePropertiesToPick.indexOf(current.dealTypeId) !== -1) {
      return acc.concat(current);
    }

    return acc;
  }, []);
}



// WEBPACK FOOTER //
// ./app/Index/utils/homes.js